import { useQueries } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { DISPENSARY_KEY } from 'tanstack-hooks/keys';

export function useDispensaries(dispensaryIds: string[]) {
  const dispensariesApi = new DispensariesApi();

  const dispensaryQueries = useQueries({
    queries: dispensaryIds.map((dispensaryId) => ({
      enabled: !!dispensaryId.length,
      queryKey: [DISPENSARY_KEY, dispensaryId],
      queryFn: () => dispensariesApi.getDispensary(dispensaryId),
      meta: {
        snackbarErrorMessage: 'There was an issue loading the CRB. Please try again.'
      }
    }))
  });

  return {
    dispensaries: dispensaryQueries.flatMap((query) => (query.data ? [query.data] : [])),
    isLoadingDispensaries: dispensaryQueries.some((query) => query.isLoading)
  };
}
